import { service } from '../axios';
export function getMessageList(data) {
    return service({
        url: '/message/list',
        method: 'post',
        data
    });
}
export function getUnreadMessageCount() {
    return service({
        url: '/message/unread/count',
        method: 'get'
    });
}
export function getStarredMessageCount() {
    return service({
        url: '/message/starred/count',
        method: 'get'
    });
}
export function getAllMessageCount() {
    return service({
        url: '/message/all/count',
        method: 'get'
    });
}
export function markMessageRead(inboxId) {
    return service({
        url: `/message/read/${inboxId}`,
        method: 'post'
    });
}
export function toggleMessageStar(inboxId) {
    return service({
        url: `/message/star/${inboxId}`,
        method: 'post'
    });
}
export function deleteMessage(inboxId) {
    return service({
        url: `/message/delete/${inboxId}`,
        method: 'post'
    });
}
export function sendExamMessageRemind(data) {
    return service({
        url: '/message/sendExamMessageRemind',
        method: 'post',
        data
    });
}
